// material-ui
import {Box} from '@mui/material';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import AuthSideImg from 'assets/images/icons/rosteric_logo_nobg.png';
import {AppButton} from 'components/buttons';
import {AppControlledCheckbox, AppControlledInput} from 'components/form';
import {AuthWrapper} from 'components/sections';
import {useLoginApi, useSessionRedux} from 'hooks';
import {LoginRequestModel} from 'models';
import {useEffect} from 'react';
import {useForm} from 'react-hook-form';

export const Login = () => {
    const {login, loginLoading, loginResponse} = useLoginApi();
    const {setSessionInRedux} = useSessionRedux();
    const {control, handleSubmit} = useForm<LoginRequestModel>({
        defaultValues: {username: '', password: '', rememberMe: false},
    });
    const subHandler = async (value: LoginRequestModel) => {
        login({
            variables: {
                input: value,
            },
        });
    };

    useEffect(() => {
        if (loginResponse && !loginLoading) {
            setSessionInRedux(loginResponse);
        }
    }, [loginResponse, loginLoading]);

    return (
        <AuthWrapper>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{textAlign: 'center'}}>
                    <Box display="flex" justifyContent={'center'} width={'100%'} padding={'10px'}>
                        <img src={AuthSideImg} alt="Authimg" width="250" height="60" />
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            {/* <MicrosoftLoginButton /> */}
                        </Grid>
                        <Grid item xs={12}>
                            {/* <GoogleLoginButton /> */}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    {/* <AuthDivider>
                        <Typography variant="body1">OR</Typography>
                    </AuthDivider> */}
                </Grid>
                <Grid item xs={12}>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="baseline"
                        sx={{mb: {xs: -0.5, sm: 0.5}}}
                    >
                        <Typography variant="h3">Login</Typography>
                    </Stack>
                </Grid>
                <Grid item xs={12}>
                    <form onSubmit={handleSubmit(subHandler)}>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <AppControlledInput
                                    label={'Email Address'}
                                    placeholder="Email"
                                    required
                                    name="username"
                                    control={control}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <AppControlledInput
                                    label={'Password'}
                                    placeholder="Password"
                                    name="password"
                                    type="password"
                                    control={control}
                                    required={'Password is required'}
                                />
                            </Grid>
                            <Grid item xs={12} sx={{mt: -1}}>
                                <AppControlledCheckbox label="Keep me sign in" name="rememberMe" control={control} />
                            </Grid>
                            <Grid item xs={12}>
                                <AppButton
                                    sx={{minHeight: '42px'}}
                                    isLoading={loginLoading}
                                    isAnimated={false}
                                    fullWidth
                                    type="submit"
                                >
                                    Login
                                </AppButton>
                            </Grid>
                        </Grid>
                    </form>
                </Grid>
            </Grid>
        </AuthWrapper>
    );
};

export default Login;
